import React from 'react';

const UserOnlineIcon = () => {
  return (
    (<svg
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="UserOnlineIcon">
      <path d="M0 9H2V11H0V9Z" fill="#1CC198" />
      <path d="M4 6H6V11H4V6Z" fill="#1CC198" />
      <path d="M8 2H10V11H8V2Z" fill="#1CC198" />
      <path d="M14 0H12V11H14V0Z" fill="#1CC198" />
    </svg>)
  );
};

export default UserOnlineIcon;
